import { ActivityIndicator } from "react-native";

export default function LoadingIndicator() {
  return <ActivityIndicator size="large" />;
}
